import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { FlexModule } from '@angular/flex-layout'
import { PipesModule } from '@mmx/pipes'
import { AuthorizationStatusPullData } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'mmx-auth-status-details',
  templateUrl: './auth-status-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    FlexModule,
    PipesModule,
  ],
  standalone: true,
})
export class AuthStatusDetailsComponent {
  @Input()
  public statusPullData: AuthorizationStatusPullData | undefined
}
